import a from"./_isKeyable.js";var r=a;var t=function(a,t){var e=a.__data__;return r(t)?e["string"==typeof t?"string":"hash"]:e.map};export{t as default};
//# sourceMappingURL=_getMapData.js.map
